import { ApplyStatus } from "./application-entity";

export const requireStatusBackWarning = (
  current: ApplyStatus,
  nextStatus: ApplyStatus,
) => {
  switch (current) {
    case "UNTREATED":
      return false;
    case "WIP":
      return nextStatus === "UNTREATED";
    case "CLOSED_COMPLETED":
    case "CLOSED_REJECTED":
    case "CLOSED_WITHDRAWN":
      throw new Error("closed status can't changed.");
  }
};

export const requirePaymentNotifWarning = (nextStatus: ApplyStatus) => {
  switch (nextStatus) {
    case "UNTREATED":
    case "WIP":
    case "CLOSED_COMPLETED":
      return false;
    case "CLOSED_REJECTED":
    case "CLOSED_WITHDRAWN":
      return true;
  }
};
